import React from 'react';

class ButtonAreaDelete extends React.Component {

    render() {

        const { removeAreaElement, index } = this.props;

        return (
            <button onClick={() => removeAreaElement(index)} className="btn-area-element-delete">
                <i className="material-icons">delete</i>
            </button>
        )
    }

}

export default ButtonAreaDelete;


// WEBPACK FOOTER //
// ./src/js/components/configuratorElements/ButtonAreaDelete.react.jsx